import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "translated-header",
  templateUrl: "translated-header.html",
})
export class TranslatedHeaderComponent implements OnInit {
  @Input() config: any;

  headerLevel: string = "1";
  className: string = "";
  translationKey: string = "missing translationKey";

  ngOnInit(): void {
    if (this.config?.attributes) {
      this.headerLevel = this.config.attributes.headerLevel || "1";
      this.className = this.config.attributes.className || "";
      this.translationKey =
        this.config.attributes.translationKey || "missing translationKey";
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/translated-header/translated-header.ts